import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-grow-1" }

import PotreeViewer from "@/components/Viewer/PotreeViewer.vue";
import AppHeader from "@/components/Pages/AppHeader.vue";
import SplitView from "@/components/Viewer/SplitView.vue";
import SplitButton from "@/components/Controls/SplitButton.vue";
import { ViewIndex } from "@/classes/data-structures/view-index";
import LayersMenu from "@/components/Viewer/LayersMenu.vue";
import MapButton from "@/components/Controls/MapButton.vue";
import ViewControls from "@/components/Controls/ViewControls.vue";
import SplitHeader from "@/components/Viewer/SplitHeader.vue";
import SplitViewTypeButton from "@/components/Controls/SplitViewTypeButton.vue";
import { nextTick, onMounted, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { useAppStateStore } from "@/store/app-state";
import { Survey } from "@/swagger";
import DefaultLayout from "@/views/layouts/DefaultLayout.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ComparePage',
  setup(__props) {

const viewer1 = ref<typeof PotreeViewer>();
const viewer2 = ref<typeof PotreeViewer>();
const route = useRoute();
const appState = useAppStateStore();

function setSecondSurvey() {
	const project = appState.project;
	if (!project) {
		return;
	}
	//Find firts survey that is not equal to current one
	let secondSurvey: Survey = project.surveys[0];
	for (var i = project.surveys.length - 1; i >= 0; i--) {
		const s = project.surveys[i];
		if (s != appState.view1Survey) {
			secondSurvey = s;
			break;
		}
	}
	appState.setView2Survey(secondSurvey)
}

onMounted(() => {
	nextTick(() => {
		viewer1.value?.copyViewFromViewer(viewer2.value);
	});
	//If second survey is not selected then select it
	if (!route.params.surveyId2) {
		//When project is loaded set second survey (if surveyId2 is set then it should already be loaded by app state)
		if (!appState.project) {
			const stopHandle = watch(() => appState.project, () => {
				setSecondSurvey();
				stopHandle();
			})
		} else {
			setSecondSurvey();
		}
	}

	console.log("Opened compare page");
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DefaultLayout, { class: "compare-page d-flex flex-column" }, {
    default: _withCtx(() => [
      _createVNode(AppHeader, { showSurvey: false }),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(SplitView, { class: "main-splitview" }, {
          view1: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(PotreeViewer, {
                viewIndex: _unref(ViewIndex).View1,
                fadeInput: false,
                pointBudgetMultiplier: 0.5,
                ref_key: "viewer1",
                ref: viewer1
              }, null, 8, ["viewIndex", "pointBudgetMultiplier"]),
              _createVNode(LayersMenu, {
                class: "layers",
                viewIndex: _unref(ViewIndex).View1
              }, null, 8, ["viewIndex"])
            ]),
            _createVNode(SplitHeader, {
              view: _unref(ViewIndex).View1,
              class: "split-header"
            }, null, 8, ["view"])
          ]),
          view2: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(PotreeViewer, {
                viewIndex: _unref(ViewIndex).View2,
                pointBudgetMultiplier: 0.5,
                fadeInput: false,
                ref_key: "viewer2",
                ref: viewer2
              }, null, 8, ["viewIndex", "pointBudgetMultiplier"])
            ]),
            _createVNode(LayersMenu, {
              class: "layers",
              viewIndex: _unref(ViewIndex).View2
            }, null, 8, ["viewIndex"]),
            _createVNode(SplitHeader, {
              view: _unref(ViewIndex).View2,
              class: "split-header"
            }, null, 8, ["view"])
          ]),
          _: 1
        }),
        _createVNode(ViewControls, { class: "view-type-toggle" }),
        _createVNode(MapButton, { class: "map-button" }),
        _createVNode(SplitViewTypeButton, { class: "split-view-type-button" }),
        _createVNode(SplitButton, { class: "split-button" })
      ])
    ]),
    _: 1
  }))
}
}

})